import React, { useEffect } from 'react';
import { Icon } from '@triumph/shared';
import { Overlay, ModalContainer, CloseButton, Content } from './Modal.styled';

export default function Modal({ content, isOpen, onClose }) {

  useEffect(() => {
      if (isOpen) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = '';
      }
  
      return () => {
        document.body.style.overflow = '';
      };
    }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <Overlay
      role="button"
      tabIndex={0}
      onClick={handleOverlayClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleOverlayClick(e);
        }
      }}
    >
      <ModalContainer>
        <CloseButton onClick={onClose}>
          <Icon name="close" width={20} height={16} />
        </CloseButton>
        <Content dangerouslySetInnerHTML={{ __html: content }} />
      </ModalContainer>
    </Overlay>
  );
}
